module.exports = __webpack_public_path__ + "img/25_44.2664e024.png";